;(() => {
  if (customElements.get('horizontal-scroll')) {
    return
  }

  class HorizontalScroll extends HTMLElement {
    constructor() {
      super()

      this.sliderConfig = {
        type: 'loop',
        arrows: false,
        pagination: false,
        waitForTransition: false,
        gap: '13rem',
        focus: 'center',
        fixedWidth: '67%',
        breakpoints: {
          990: {
            fixedWidth: '89%',
            gap: '2rem',
          },
        },
      }
      this.initSliderHandler = this.initSlider.bind(this)
    }

    connectedCallback() {
      this.initSliderHandler()
    }

    initSlider() {
      const slider = this.querySelector('.splide')

      if (!slider) {
        return
      }

      this.sliderInstance = new Splide(slider, this.sliderConfig).mount()

      return this.sliderInstance
    }
  }

  customElements.define('horizontal-scroll', HorizontalScroll)
})()
